/**
 * Maps a file path to a Monaco editor language identifier.
 *
 * @param path - The file path to determine language for.
 * @returns The Monaco language identifier, or undefined if the extension is not recognized.
 */
export function langFromPath(path: string): string | undefined {
  const ext = path.split('.').pop()?.toLowerCase()
  const map: Record<string, string> = {
    ts: 'typescript',
    tsx: 'typescript',
    js: 'javascript',
    mjs: 'javascript',
    cjs: 'javascript',
    jsx: 'javascript',
    json: 'json',
    html: 'html',
    css: 'css',
    md: 'markdown',
    yaml: 'yaml',
    yml: 'yaml',
    sql: 'sql',
    sh: 'shell',
    env: 'plaintext',
  }
  return ext ? map[ext] : undefined
}
